/**
 * Supabase auth configuration.
 *
 * Auth tokens are stored in the browser's default localStorage via Supabase.
 * The real auth boundary is PKCE + HTTPS + server-side verification — in-browser
 * encryption with keys that also live in-browser provides no additional protection
 * against XSS and previously caused PKCE flows (password reset, email confirmation)
 * to fail due to a sync/async storage-adapter mismatch.
 */

export const createSecureSupabaseConfig = () => ({
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true,
    flowType: 'pkce' as const,
  },
});

/**
 * Clears any auth-related keys that Supabase may have written to localStorage.
 * Supabase's own signOut() also clears these, so this is a belt-and-braces helper
 * used for defensive cleanup paths (e.g. error handling).
 */
export const clearSecureAuthStorage = () => {
  try {
    Object.keys(localStorage)
      .filter((key) => key.startsWith('sb-'))
      .forEach((key) => localStorage.removeItem(key));
  } catch (error) {
    console.error('Error clearing auth storage:', error);
  }
};
